module.exports = __webpack_public_path__ + "img/kin2.a9e25210.jpg";